<template>
  <a-layout-sider
    v-model="collapsed"
    :theme="sideTheme"
    :class="['side-menu', 'beauty-scroll', isMobile ? null : 'shadow']"
    width="264px"
    collapsed-width="60px"
    :collapsible="collapsible"
    :trigger="null">
    <div :class="['logo', theme]">
      <router-link class="logo-contenair" :to="filterTo()">
        <img v-if="collapsed" class="logo-small" src="@/assets/img/logo-small.png">
        <img v-else class="logo-big" src="@/assets/img/title_web_huozhu.png">
      </router-link>
    </div>
    <div v-if="isOrderBtn" class="create-order">
      <router-link to="/order/createOrder">
        <div v-show="!collapsed" :class="['order-big', $route.path === '/order/createOrder' ? 'current-order' : '']">
          <img src="../../assets/img/icon-order-btn.png" alt="">
          <span>在线下单</span>
        </div>
        <div v-show="collapsed" class="order-small">
          <img src="../../assets/img/icon-order-btn.png" alt="">
        </div>
      </router-link>
    </div>
    <i-menu
      :theme="theme"
      :collapsed="collapsed"
      :count="count" 
      :options="menuData"
      class="menu"
      @select="onSelect"
    />
    <a :class="['trigger', collapsed ? 'collapsed': '' ]" @click="toggleCollapse">
      <i class="iconfont icon-fold_20x20"  />
    </a>
  </a-layout-sider>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '@/utils/event-bus'
import store from '@/store'
import ButtonPermission from '@/constants/buttonPermission'
import IMenu from './menu'

export default {
  name: 'SideMenu',
  components: { IMenu },
  props: {
    collapsible: {
      type: Boolean,
      required: false,
      default: false,
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    menuData: {
      type: Array,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: 'dark',
    },
    count: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    sideTheme() {
      return this.theme === 'light' ? this.theme : 'dark'
    },
    ...mapState('setting', ['isMobile', 'systemName', 'layout']),
    ...mapState('user', ['buttonPermission']),
    isOrderBtn(){
      return this.buttonPermission&&this.buttonPermission.length?this.buttonPermission.some(item=>item.uri=== ButtonPermission.ORDER_ORDERONLINE):false
    }
  },
  methods: {
    filterTo(){
      if(!this.$store.state.user.customerId){
        return '/authentication'
      }
      return '/'
    },
    toggleCollapse () {
      this.$emit('toggleCollapse')
      EventBus.$emit('onshrink', !this.collapsed)
    },
    onSelect (obj) {
      store.dispatch('user/initSelect')
      this.$emit('menuSelect', obj)
      EventBus.$emit('searchOrderList')
    },
  },
}
</script>

<style lang="less" scoped>
@import 'index';
</style>
